import { render, staticRenderFns } from "./ClusterCard.vue?vue&type=template&id=ed6080ec"
import script from "./ClusterCard.vue?vue&type=script&lang=js"
export * from "./ClusterCard.vue?vue&type=script&lang=js"
import style0 from "./ClusterCard.vue?vue&type=style&index=0&id=ed6080ec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports